import {HttpResponse} from '@angular/common/http';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {JhiAlertService, JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {
  ITEMS_PER_PAGE,
  PAGE_SIZE_OPTIONS,
} from '@shared/constants/pagination.constants';
import {IActivityParam} from '@entities/activity/activity.model';
import {ActivityService} from '@entities/activity/activity.service';

@Component({
  selector: 'app-activity-type-param',
  templateUrl: './activity-type-param.component.html',
  styleUrls: ['./activity-type-param.component.scss'],
})
export class ActivityTypeParamComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'name',
    // 'description',
    'tbControlTypeName',
    'unit',
    'isGuidelineUsing',
    'isActivity',
    'isShowInfo',
    'isCountIncrease',
    'isCountLess',
    'isMandatory',
    'position',
    'action',
  ];
  dataSource: any;
  pageSizeOptions: number[];
  ELEMENT_DATA: IActivityParam[];
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  eventSubscriber: Subscription;
  id: any;
  noData: boolean;
  isLoading = true;
  constructor(
    private activityService: ActivityService,
    private alertService: JhiAlertService,
    private eventManager: JhiEventManager,
    private parseLinks: JhiParseLinks,
    private activatedRoute: ActivatedRoute,
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.ELEMENT_DATA = [];
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
    this.page = 1;
    this.id = this.activatedRoute.snapshot.params.id
      ? this.activatedRoute.snapshot.params.id
      : '';
  }

  ngOnInit() {
    this.loadAll();
    this.changedListType();
  }

  ngOnDestroy() {
    this.eventManager.destroy(this.eventSubscriber);
  }

  changedListType() {
    this.eventSubscriber = this.eventManager.subscribe(
      'activityParamListModification',
      (response) => this.loadAll(),
    );
  }

  loadAll() {
    this.isLoading = true;
    this.activityService
      .queryParam(this.id, {
        page: this.page - 1,
        size: this.itemsPerPage,
      })
      .subscribe(
        (res: HttpResponse<IActivityParam[]>) =>
          this.onSuccess(res.body, res.headers),
        (res: HttpResponse<any>) => this.onError(res.body),
      );
  }

  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.transition();
  }

  clear() {
    this.page = 1;
    this.loadAll();
  }

  private transition() {
    this.loadAll();
  }

  private onSuccess(data: any, headers: any) {
    this.isLoading = false;
    this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    if (data.length === 0) {
      this.noData = true;
    } else {
      this.noData = false;
    }
    this.ELEMENT_DATA = data;
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  }

  private onError(error: any) {
    this.isLoading = false;
    this.alertService.error(error.error, error.message, null);
  }
}
